import { render, staticRenderFns } from "./waterQualityTotal.vue?vue&type=template&id=bce19974&scoped=true"
import script from "./waterQualityTotal.vue?vue&type=script&lang=js"
export * from "./waterQualityTotal.vue?vue&type=script&lang=js"
import style0 from "./waterQualityTotal.vue?vue&type=style&index=0&id=bce19974&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce19974",
  null
  
)

export default component.exports